import Cookies from 'goog:goog.net.Cookies';

import ReviewResponseSettings from 'goog:yext.social.reviewresponse.settings';
import ComplianceSettingsView from 'goog:yext.storm.ComplianceSettingsView';

import {KnowledgeGraphSettingsStorm} from '/js/yext/storm/routes';

import jsInit from '/js/yext/jsinit';
import * as toast from '/ui/components/toast/toast';
goog.require('yext.storm.account.partner');


const TOAST_COOKIE_PREFIX = 'kgConfigToast-';
const TOAST_MAX_AGE = 60 * 60 * 24 * 90; // 3 months
const TopLevelFolders = goog.require('yext.storm.common.TopLevelFolders');

/**
 * @suppress {strictCheckTypes}
 * Renders the static toast for the KM links.
 */
function render() {
  const cookieKey = TOAST_COOKIE_PREFIX + yext.userId;
  const showToast =
    document.getElementById('show-toast').dataset.showToast === 'true'
    && !Cookies.getInstance().get(cookieKey);
  if (showToast) {
    const toastMessage =
      yext.msg(
        'Some Content and Templates related settings have been moved, and now can be ' +
          'found in the new Knowledge Graph <a href={0}>Configuration Tab</a>.',
        KnowledgeGraphSettingsStorm.viewSettings());
    toast.showNeutralToast(
      <span dangerouslySetInnerHTML={{__html: toastMessage}} />,
      true,
      {onClose: () => setCookie(cookieKey)},
    );
  }
}

/**
 * Sets the value "true" for the supplied cookie key.
 *
 * @param cookieKey The cookie key to set.
 */
function setCookie(cookieKey) {
  const cookieSettings = {maxAge: TOAST_MAX_AGE, path: '/s/' + yext.businessId};
  Cookies.getInstance().set(cookieKey, 'true', cookieSettings);
}

/**
 * Initialize top level folders
 */
function topLevelFoldersInit(params) {
  TopLevelFolders.init(params);
}

/**
 * Set non-root folders
 */
function setNonRootFolders() {
  window.hasNonRootFolders = true;
}

const init = jsInit({
  'renderToast': render,
  'reviewResponseSettings': ReviewResponseSettings.init,
  'complianceSettings': params => new ComplianceSettingsView(params),
  'topLevelFolders': topLevelFoldersInit,
  'setNonRootFolders': setNonRootFolders,
});

function initPartnerAccount(params) {
  const partnerIds = params['appInfos'];
  const partnerIdsArr = partnerIds.split(',').filter(element => element);
  yext.storm.account.partner.init(partnerIdsArr);
}

const partnerInit = jsInit({
  'partner-account-init': initPartnerAccount,
}, '.js-init-partner-account');

document.addEventListener('DOMContentLoaded', init);
window.addEventListener('load', partnerInit);
